<template>
  <div class="mod-flash-order">
    <DomTable
      :stock="stock"
      :symbol="symbol"
      :is-tradable="isTradable"
      :min-ticks="minTicks"
      :holding="holding"
      @cancelOrder="cancelOrder"
      @tradeStock="newOrder"
    />
    <PositionList v-if="holding" :holding="holding" :stock="stock" />
    <QuantityInput v-model="quantity" :step="step" />
    <FunButtons
      :position-num="positionNum"
      :quantity="quantity"
      :is-tradable="isTradable"
      :stock="stock"
      @tradeStock="newOrder"
    />
    <OrderConfirm
      :order="order"
      :type="confirmOrder.type"
      :visible="showOrderConfirm"
      @closeConfirm="closeOrderConfirm"
    />
    <TradePassword v-if="showTradePassword" @close="closeTradePassword" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import FunButtons from './FunButtons'
import PositionList from './PositionList'
import DomTable from './DomTable'
import QuantityInput from './QuantityInput'
import OrderConfirm from 'mod/TradeDialogs/OrderConfirm'
import TradePassword from 'mod/TradeDialogs/TradePassword'
import orderTradeMixin from './mixins/orderTradeMixin'
import stockMixin from 'mixins/stockMixin'
import stockHoldingPollMixin from 'mixins/stockHoldingPollMixin'
import bus from 'src/eventbus'
import isStockTradable from 'utils/isStockTradable'
import { ORDER_TYPE } from 'const/trade'

export default {
  name: 'FlashOrder',
  components: {
    DomTable,
    PositionList,
    QuantityInput,
    FunButtons,
    OrderConfirm,
    TradePassword
  },
  mixins: [stockHoldingPollMixin, orderTradeMixin, stockMixin],
  props: {
    stock: Object,
    contract: Object
  },
  data() {
    return {
      confirmOrder: {
        orderId: '',
        type: 'create', // create/cancel
        isCloseout: false,
        cancelIds: [], // 需要取消的订单ID列表
        orderType: ORDER_TYPE.MKT,
        limitPrice: '',
        action: 'BUY',
        position: 0
      },
      quantity: 0
    }
  },
  watch: {
    symbol() {
      this.setInitQuantity()
      this.getStockHoldingsAndOrders()
    },
    curAccountId() {
      this.getStockHoldingsAndOrders()
    },
    lotSize() {
      this.setInitQuantity()
    },
    isShowSideStockView(show) {
      if (show) return
      // 期权链侧边栏关闭，更新闪电下单持仓信息
      this.getStockHoldingsAndOrders()
    }
  },
  computed: {
    ...mapGetters([
      'curAccountId',
      'isVirtual',
      'isIb',
      'curStockHoldings',
      'isShowSideStockView',
      'hasValidTradeToken'
    ]),
    isTradable() {
      return isStockTradable(this.stock, this.contract, this.$store.getters)
    },
    minTicks() {
      return this.contract ? this.contract.tickSizes : []
    },
    holding() {
      return this.curStockHoldings[0]
    },
    positionNum() {
      return (this.holding && this.holding.position) || 0
    },
    symbol() {
      return this.stock.webLocal
        ? this.stock.webLocal.symbol
        : this.stock.symbol
    },
    step() {
      return this.getMinTick()
    },
    lotSize() {
      return this.stock.lotSize
    }
  },
  created() {
    this.getNewIbOrderId()
    bus.on(bus.$events.MANUAL_REFRESH_DOM, this.getStockHoldingsAndOrders)
    this.$on('hook:beforeDestroy', () => {
      bus.off(bus.$events.MANUAL_REFRESH_DOM, this.getStockHoldingsAndOrders)
    })
  },
  mounted() {
    this.setInitQuantity()
    this.getStockHoldingsAndOrders()
  },
  methods: {
    getStockHoldingsAndOrders() {
      this.$store.dispatch('getActiveStockHoldingsAndOrders', this.stock)
    },
    getNewIbOrderId() {
      this.$store.dispatch('getNewIbTradeOrderId').then(orderId => {
        this.confirmOrder.orderId = orderId
      })
    },
    getMinTick() {
      if (this.isHK) return this.lotSize
      if (this.isOPT) return 1
      if (this.quantity >= 300) return 100
      if (this.quantity >= 50) return 10
      return 1
    },
    setInitQuantity() {
      // 由于 minTick 会根据 quantity 计算，因此需要先重置 quantity
      this.quantity = 0
      this.quantity = this.getMinTick()
    }
  }
}
</script>
<style lang="less">
@import '~uikit';
.mod-flash-order {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 15px 0;
}
.trade-warning-modal {
  .highlight {
    color: var(--active-color);
  }
  .paragraph {
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
